// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
let inst;

export const code2name = code=>{
    try {
        if (!inst)
            inst = new Intl.DisplayNames(['en'], {type: 'region'});
        return inst.of(code);
    } catch(e){
        console.log(e);
        return code;
    }
};
